import { Component } from '@angular/core';

@Component({
  selector: 'app-home-section-main',
  standalone: true,
  imports: [],
  templateUrl: './home-section-main.component.html',
  styleUrls: ['./home-section-main.component.scss'],
})
export class HomeSectionMainComponent {}
